import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/theme/imgs/default_campo.png'
import _imports_1 from '@/theme/imgs/pallina_empty.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-7d8d093a")

_pushScopeId("data-v-7d8d093a")
const _hoisted_1 = {
  class: "header",
  id: "scheduler-header"
}
const _hoisted_2 = { class: "first-row padding-bottom-20 padding-top-20 margin-left-40" }
const _hoisted_3 = { class: "scheduler-title color-white" }
const _hoisted_4 = {
  key: 0,
  class: "flexbox-row align-center"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "vl" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "p-d-flex p-flex-column p-flex-sm-row p-jc-between margin-left-40 sub-header"
}
const _hoisted_7 = { class: "display-flex calendar-selector" }
const _hoisted_8 = { class: "display-flex" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "vl" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "vl" }, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "chip-container"
}
const _hoisted_12 = { class: "chip-content" }
const _hoisted_13 = { class: "chip-text" }
const _hoisted_14 = {
  key: 2,
  class: "third-row playground-box"
}
const _hoisted_15 = { class: "table-head display-flex" }
const _hoisted_16 = { class: "image-container" }
const _hoisted_17 = {
  key: 1,
  src: _imports_0,
  class: "image-circle"
}
const _hoisted_18 = { class: "calendar-header-description" }
const _hoisted_19 = { class: "calendar-header-title" }
const _hoisted_20 = { class: "calendar-header-address color-white" }
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = {
  class: "position-relative flexbox-row",
  style: {"width":"100%"}
}
const _hoisted_23 = {
  key: 3,
  class: "third-row playground-box"
}
const _hoisted_24 = { class: "image-container" }
const _hoisted_25 = {
  key: 1,
  src: _imports_0,
  class: "image-circle"
}
const _hoisted_26 = { class: "calendar-header-description" }
const _hoisted_27 = { class: "calendar-header-title" }
const _hoisted_28 = { class: "calendar-header-address color-white" }
const _hoisted_29 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_30 = {
  class: "position-relative flexbox-row",
  style: {"width":"100%"}
}
const _hoisted_31 = {
  key: 0,
  class: "cal-container margin-bottom-20"
}
const _hoisted_32 = { class: "closing-hour position-absolute barlow" }
const _hoisted_33 = {
  key: 1,
  class: "empty-playgrounds-container"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_35 = { class: "color-white empty-text-title margin-top-20" }
const _hoisted_36 = { class: "color-white empty-text" }
const _hoisted_37 = { class: "scheduler-button-text color-blue" }
const _hoisted_38 = /*#__PURE__*/_createVNode("i", { class: "pi pi-plus color-blue" }, null, -1)
const _hoisted_39 = {
  key: 2,
  class: "cal-container p-mb-0 margin-left-40"
}
const _hoisted_40 = { key: 3 }
const _hoisted_41 = { class: "flexbox-row filter-modal-top-part" }
const _hoisted_42 = { class: "main-filter-container" }
const _hoisted_43 = { class: "dropdown-container" }
const _hoisted_44 = { class: "dropdown-container" }
const _hoisted_45 = { class: "radio-container" }
const _hoisted_46 = { class: "color-white montserrat" }
const _hoisted_47 = { class: "radio-container" }
const _hoisted_48 = { class: "color-white montserrat" }
const _hoisted_49 = { class: "filter-buttons-container flexbox-row" }
const _hoisted_50 = { class: "flexbox-row" }
const _hoisted_51 = { key: 4 }
const _hoisted_52 = { key: 5 }
const _hoisted_53 = { key: 6 }
const _hoisted_54 = { key: 7 }
const _hoisted_55 = { key: 8 }
const _hoisted_56 = { key: 9 }
const _hoisted_57 = { class: "top-part flexbox-column align-center" }
const _hoisted_58 = /*#__PURE__*/_createVNode("i", { class: "material-icons icon-alert margin-bottom-20" }, "warning_amber", -1)
const _hoisted_59 = { class: "color-white alert-text montserrat" }
const _hoisted_60 = {
  key: 0,
  class: "color-white alert-text montserrat"
}
const _hoisted_61 = { class: "color-white alert-text montserrat" }
const _hoisted_62 = { class: "color-white alert-text montserrat margin-top-20" }
const _hoisted_63 = { style: {"color":"#E64040"} }
const _hoisted_64 = /*#__PURE__*/_createVNode("div", {
  class: "color-white alert-text montserrat margin-top-20 margin-bottom-20",
  style: {"padding":"20px","border":"1px solid #38A8FC","text-align":"left"}
}, [
  /*#__PURE__*/_createVNode("span", { style: {"color":"#38A8FC"} }, "VUOI RIMBORSARE IL GIOCATORE?"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("Se annulli la prenotazione il rimborso non è automatico."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("Per rimobrsare il giocatore vai nella sezione ”Pagamenti”. ")
], -1)
const _hoisted_65 = { class: "filter-buttons-container flexbox-row" }
const _hoisted_66 = { class: "flexbox-row" }
const _hoisted_67 = { key: 10 }
const _hoisted_68 = { class: "top-part flexbox-column align-center" }
const _hoisted_69 = /*#__PURE__*/_createVNode("i", { class: "material-icons icon-alert margin-bottom-20" }, "warning_amber", -1)
const _hoisted_70 = { class: "color-white alert-text montserrat" }
const _hoisted_71 = { class: "filter-buttons-container flexbox-row" }
const _hoisted_72 = { class: "flexbox-row" }
const _hoisted_73 = { key: 11 }
const _hoisted_74 = { class: "top-part flexbox-column align-center" }
const _hoisted_75 = /*#__PURE__*/_createVNode("span", { class: "material-icons-outlined reject-icon" }, "error_outline", -1)
const _hoisted_76 = { class: "color-white alert-text montserrat" }
const _hoisted_77 = { class: "color-white alert-text montserrat" }
const _hoisted_78 = { class: "drag-error-buttons flexbox-row" }
const _hoisted_79 = { key: 12 }
const _hoisted_80 = { class: "top-part flexbox-column align-center" }
const _hoisted_81 = /*#__PURE__*/_createVNode("span", { class: "material-icons-outlined reject-icon" }, "error_outline", -1)
const _hoisted_82 = { class: "color-white alert-text montserrat" }
const _hoisted_83 = { class: "color-white alert-text montserrat" }
const _hoisted_84 = { class: "drag-error-buttons flexbox-row" }
const _hoisted_85 = { key: 13 }
const _hoisted_86 = {
  key: 0,
  class: "top-part flexbox-column align-center"
}
const _hoisted_87 = { class: "color-white alert-text montserrat margin-bottom-20 p-text-left" }
const _hoisted_88 = { class: "form-excel-container flexbox-row" }
const _hoisted_89 = { class: "flexbox-row align-center flex-100" }
const _hoisted_90 = { class: "download-button" }
const _hoisted_91 = /*#__PURE__*/_createVNode("img", { src: "/images/template_download.png" }, null, -1)
const _hoisted_92 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_93 = { class: "flexbox-row align-center flex-100" }
const _hoisted_94 = /*#__PURE__*/_createVNode("img", { src: "/images/template_download.png" }, null, -1)
const _hoisted_95 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_96 = {
  key: 1,
  class: "top-part flexbox-column align-center"
}
const _hoisted_97 = { class: "upload-form flexbox-row" }
const _hoisted_98 = { class: "flexbox-row align-center w-100 flex-100 p-mt-5" }
const _hoisted_99 = {
  key: 2,
  class: "top-part flexbox-column align-center"
}
const _hoisted_100 = { class: "top-part flexbox-column align-center" }
const _hoisted_101 = /*#__PURE__*/_createVNode("div", { class: "icon-alert margin-bottom-20" }, [
  /*#__PURE__*/_createVNode("img", { src: "/images/elaborating_icon.png" })
], -1)
const _hoisted_102 = { class: "color-white alert-text montserrat" }
const _hoisted_103 = {
  key: 3,
  class: "top-part flexbox-column align-center"
}
const _hoisted_104 = { class: "top-part flexbox-column align-center" }
const _hoisted_105 = /*#__PURE__*/_createVNode("div", { class: "icon-alert margin-bottom-20" }, [
  /*#__PURE__*/_createVNode("img", { src: "/images/error_icon.png" })
], -1)
const _hoisted_106 = { class: "color-white alert-text montserrat" }
const _hoisted_107 = { class: "buttons-container flexbox-row justify-space-between" }
const _hoisted_108 = { key: 14 }
const _hoisted_109 = { class: "top-part flexbox-column align-center" }
const _hoisted_110 = /*#__PURE__*/_createVNode("i", { class: "material-icons icon-alert margin-bottom-20" }, "warning_amber", -1)
const _hoisted_111 = { class: "color-white alert-text montserrat" }
const _hoisted_112 = { class: "buttons-bundle-dialog flexbox-row" }
const _hoisted_113 = {
  key: 0,
  class: "flexbox-row"
}
const _hoisted_114 = { class: "flexbox-row" }
const _hoisted_115 = { class: "flexbox-row" }
_popScopeId()

import { BookingType, CalendarOpenings } from "@/constants/booking.enum";
import { ClubStatus } from "@/constants/club-status.enum";
import { ToastErrors } from "@/constants/generic-errors.enum";
import {
  END_OF_AFTERNOON,
  END_OF_MORNING,
  getSportByValue,
  sportOptions,
} from "@/constants/radio-options.constants";
import { PadelClub } from "@/models/club.models";
import { PadelPlayground } from "@/models/playground.models";
import {
  CalendarTimeslot,
  TimeslotInfo,
  VueCalEvent,
} from "@/models/timeslots.models";
import { PadelUser } from "@/models/user.models";
import {
  changeDateTime,
  convertEventTimeToMinutesOfDay,
  convertMinutesOfDayToHHMM,
  formatDateMMDDYYYY,
  formatDateYYYYMMDD,
  isDateBefore,
  isToday,
  mapTimestamp,
  returnDateAdMidnight,
  returnTomorrow,
  returnYesterday,
  transformMillisecondsToHHMM,
  transformStringToDate,
} from "@/services/dates.service";
import { showToast } from "@/services/error-management.service";
import {
  constructPlaygroundMap,
  filteredEvents,
  filteredPlaygrounds,
  filteredTimeFrom,
  filteredTimeTo,
  isFilterActive,
  mapCalendarFormToFilters,
  mapCancelBookingPayload,
  mapContentForTooltip,
  mySportsByPlaygrounds,
  refactorEvents,
  refactorPlaygrounds,
  removedFilterArray,
  transformCalendarFilterOptions,
  transformPlaygroundsToOptions,
  uppercase,
} from "@/services/mapping.service";
import { ActionTypes } from "@/store/action-types";
import { MutationTypes } from "@/store/mutation-types";
import { useStore } from "@/store/store";
import moment from "moment";
import {
  computed,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from "vue";
import VueCal from "vue-cal";
import "vue-cal/dist/drag-and-drop.js";
import "vue-cal/dist/i18n/it.js";
import "vue-cal/dist/vuecal.css";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";


export default _defineComponent({
  setup(__props) {

const router = useRouter();
const store = useStore();
const { t } = useI18n();
const timeCellHeight = ref(50);
const timeFrom = ref(null);
const timeTo = ref(null);
const tempDeleted = ref(null);
const display = ref(false);
const splits = ref([]);
const show_calendar = ref(false);
const playgrounds = ref([]);
const rawCalendarEvents = ref([]);
const events = ref([]);
const showCalendarBox = ref(false);
const playgroundPages = ref([]);
const currentPage = ref(0);
const modalToShow = ref(null);
const deleteClicked = ref(false);
const activeFilters = ref([]);
const filtersForm = ref([
  { type: "playground", value: null, label: null },
  { type: "timeslot", value: null, label: null },
  { type: "sport", value: null, label: null },
  { type: "visibility", value: null, label: t("private") },
]);
const detailBooking = ref(null);
const openMatchTimeslotId = ref(null);
let pageWindow = 6;
const MIN_WIDTH_SIZE = 200;
const playgroundMap = ref({});
const bookingToDelete = ref(null);
const tournamentDetails = ref(null);
const provvNewEvent = ref(null);
const specialHours = ref({});
const uploadStep = ref(1);
const uploadPlayground = ref(null);
const uploadFile = ref(null);
const fileUploader = ref(null);

// const START_OF_DAY = 0;
// const END_OF_DAY = 24 * 60;

const filtersTimeslotsApplied = ref(false);

const showPriceRules = ref(false);
const tooltipId = ref(null);
const tooltipX = ref(0);
const tooltipY = ref(0);

/* COMPUTED */
const myClub = computed(function (): PadelClub {
  return store.getters.getMyClub;
});

const myClubStatus = computed(function (): string {
  return store.getters.getMyClub.status;
});

const selectedDate = computed(function (): Date {
  return store.getters.getCurrentDate
    ? new Date(store.getters.getCurrentDate)
    : undefined;
});

const clubTimeFrom = myClub.value.opening_hour / 1000 / 60;
const clubTimeTo = myClub.value.closing_hour / 1000 / 60;

const computedTimeFrom = ref(clubTimeFrom);
const computedTimeTo = ref(clubTimeTo);

const createValue = computed(function () {
  return (
    isDateBefore(new Date(), selectedDate.value) ||
    isToday(selectedDate.value)
  );
});

const allPlaygrounds = computed(function (): PadelPlayground[] {
  return store.getters.getMyPlaygrounds;
});
const mySports = computed(function () {
  return mySportsByPlaygrounds(allPlaygrounds.value);
});

//CHECK FALSE ENABLES DISABLED CLUBS TO CREATE EVENTS
function isMyClubDisabled(check = false) {
  if (check) {
    return myClubStatus.value === ClubStatus.DISABLED;
  } else return false;
}

const new__booking = computed(function (): string {
  if (playgrounds.value.length <= 0) {
    return "disabled";
  } else {
    if (isMyClubDisabled()) {
      return "color-disabled";
    } else {
      return "";
    }
  }
});

async function changePageWindowSize() {
  const calendarTable = document.getElementsByClassName("vuecal__cells");
  // Defensive check: ensure calendar element exists before accessing offsetWidth
  if (calendarTable.length > 0 && calendarTable[0]) {
    const columns = Math.floor(
      (calendarTable[0] as HTMLElement).offsetWidth / MIN_WIDTH_SIZE
    );
    if (columns > 0) {
      pageWindow = columns;
    } else {
      pageWindow = 1;
    }
  } else {
    // Fallback to default when calendar is not yet rendered
    pageWindow = 1;
  }
}

function calculateSplits() {
  splits.value = [];
  playgroundPages.value[currentPage.value].forEach((court, index) => {
    splits.value.push({ id: index + 1, playground: court.id });
  });
  events.value.forEach((event) => {
    event.split = null;
    playgroundPages.value[currentPage.value].forEach((court, index) => {
      if (event.playground_id === court.id) {
        event.split = index + 1;
        event.playground_name = court.name;
        event.timeslotInfo
          ? (event.timeslotInfo.playground_name = court.name)
          : "";
      }
    });
  });
}

function findSubArrays(array, window: number) {
  if (array.length <= window) {
    return [array];
  }
  const provv = [];
  for (let i = 0; i < array.length; i++) {
    const subArray = array.slice(i, window + i);
    if (subArray.length === window) {
      provv.push(subArray);
    }
  }
  return provv;
}

function returnFilter(type: string) {
  return activeFilters.value.find((filter) => filter.type === type);
}

function reportWindowSize(needToRefactorEvents = false) {
  changePageWindowSize();
  playgroundPages.value = findSubArrays(playgrounds.value, pageWindow);
  if (needToRefactorEvents) {
    events.value = refactorEvents(
      rawCalendarEvents.value,
      myClub.value,
      t,
      allPlaygrounds.value
    );
  }
  calculateSplits();
}

//RECALCULATE COLUMNS EVERY TIME THERE IS A RESIZE
window.onresize = () => {
  reportWindowSize(false);
};

const playgroundOptions = computed(function () {
  return transformPlaygroundsToOptions(playgrounds.value);
});

const computedPlaygrounds = computed(function (): {
  value: string;
  label: string;
  sport: string;
}[] {
  return playgroundOptions.value.filter(
    (el) => el.sport === filtersForm.value[2].value
  );
});

const computedCalendarFilterOptions = computed(function () {
  return transformCalendarFilterOptions(
    myClub.value.opening_hour,
    myClub.value.closing_hour
  );
});

const computedEvents = computed(function () {
  if (
    activeFilters.value.length > 0 &&
    (isFilterActive(activeFilters.value, "playground") ||
      isFilterActive(activeFilters.value, "sport") ||
      isFilterActive(activeFilters.value, "visibility"))
  ) {
    return filteredEvents(
      events.value,
      allPlaygrounds.value,
      (returnFilter("playground") || {}).value,
      (returnFilter("sport") || {}).value,
      (returnFilter("visibility") || {}).value
    );
  } else return events.value;
});

const computedSplits = computed(function () {
  return splits.value;
});

async function getPlaygrounds(club_id: string): Promise<PadelPlayground[]> {
  try {
    const pl = await store.dispatch(ActionTypes.GET_PLAYGROUNDS, club_id);
    return pl;
  } catch (error) {
    return;
  }
}

async function getCalendarEvents(payload) {
  try {
    const timeslots = await store.dispatch(
      ActionTypes.GET_CALENDAR_EVENTS,
      payload
    );
    return timeslots;
  } catch (error) {
    return;
  }
}

const delay = (ms) => new Promise((res) => setTimeout(res, ms));

async function initializeEvents(date: string, hideLoader?: boolean) {
  showCalendarBox.value = false;

  const dateString = formatDateMMDDYYYY(date);

  try {
    await getCalendarEvents({
      club_id: myClub.value.club_id,
      date: dateString,
      hideLoader: hideLoader,
    }).then(async (val) => {
      rawCalendarEvents.value = val;
      events.value = refactorEvents(
        rawCalendarEvents.value,
        myClub.value,
        t,
        allPlaygrounds.value
      );
    });
    calculateSplits();
  } catch (err) {
    return;
  }
}

function displayClosingHours(openMillis, closeMillis) {
  const _specialHours = {};
  for (let i = 1; i <= 7; i++) {
    _specialHours[i] = [
      //{ from: 0 * 60, to: openMillis / 1000 / 60, class: "closed" },
      {
        from: openMillis / 1000 / 60,
        to: closeMillis / 1000 / 60,
        class: "special-hours-opened",
      },
      //{ from: closeMillis / 1000 / 60, to: 24 * 60, class: "closed" },
    ];
  }
  specialHours.value = _specialHours;
}

function initializeCalendarBoundaries(openMillis, closeMillis) {
  displayClosingHours(openMillis, closeMillis);
  timeFrom.value = openMillis / 1000 / 60;
  timeTo.value = closeMillis / 1000 / 60;
}

function scrollIntoElement(element) {
  const header = document.getElementById("scheduler-header");
  const offset = 10;
  const topOfElement =
    window.pageYOffset +
    element.getBoundingClientRect().top -
    header.scrollHeight -
    offset;
  window.scroll({ top: topOfElement, behavior: "smooth" });
}

function scrollToOpenedHour(className: string) {
  const firstOpenedElements = document.getElementsByClassName(className);
  if (firstOpenedElements[0]) {
    scrollIntoElement(firstOpenedElements[0]);
  } else {
    setTimeout(() => {
      scrollToOpenedHour(className);
    }, 100);
  }
}

function handleClickCalendar(event) {
  const specifiedElement = document.getElementById(
    "toggle-calendar-button"
  );
  if (!specifiedElement) return;
  const schedulerBox = document.getElementById("calendar-scheduler-box");
  const isMonthPickClicked =
    (event.target as HTMLElement).classList.contains(
      "p-datepicker-prev-icon"
    ) ||
    (event.target as HTMLElement).classList.contains("p-datepicker-prev") ||
    (event.target as HTMLElement).classList.contains(
      "p-datepicker-next-icon"
    ) ||
    (event.target as HTMLElement).classList.contains(
      "p-datepicker-next-icon"
    );
  const isClickInside = specifiedElement.contains(event.target as Node);
  const isClickInsideCalendar = schedulerBox.contains(event.target as Node);
  if (isMonthPickClicked || isClickInsideCalendar) {
    show_calendar.value = true;
  } else if (!isClickInside) {
    show_calendar.value = false;
  }
}

function handleButtonCalendarClickOut() {
  document.addEventListener("click", handleClickCalendar);
}

onUnmounted(() => {
  document.removeEventListener("click", handleClickCalendar);
  store.commit(MutationTypes.RESET_CURRENT_DATE, null);
});

function initializeFilterForm() {
  filtersForm.value = [
    { type: "playground", value: null, label: null },
    { type: "timeslot", value: null, label: null },
    { type: "sport", value: null, label: null },
    { type: "visibility", value: null, label: t("private") },
  ];
}

function initializeDetailBooking() {
  detailBooking.value = null;
}

function initializeTournamentDetail() {
  tournamentDetails.value = null;
}

const userHasCards = ref(false);

async function checkUserHasCards(userId: string) {
  const response = await store.dispatch(ActionTypes.GET_CARDS, {
    user_id: userId,
    limit: 1,
  });
  return response.data.records.length > 0;
}

async function openModal(modal: string) {
  if (modal === "BOOKING_DETAIL") {
    userHasCards.value = await checkUserHasCards(
      detailBooking.value.wesmash_user_id
    );
  }

  if (
    modalToShow.value === "SURE_WANNA_DELETE" &&
    modal === "BOOKING_DETAIL"
  ) {
    return;
  } else {
    modalToShow.value = modal;
  }
}

function hideModal() {
  initializeFilterForm();
  initializeDetailBooking();
  initializeTournamentDetail();
  modalToShow.value = null;
  bookingToDelete.value = null;
  provvNewEvent.value = null;
  uploadStep.value = 1;
  uploadPlayground.value = null;
  uploadFile.value = null;
}

function checkIfClubDisabled() {
  if (isMyClubDisabled(true)) {
    openModal("CLUB_DISABLED");
  }
}

async function initializeEventsInCalendar() {
  playgroundPages.value = findSubArrays(playgrounds.value, pageWindow);
  await initializeEvents(selectedDate.value.toISOString());
  initializeCalendarBoundaries(
    myClub.value.opening_hour,
    myClub.value.closing_hour
  );
}

function handleOrientation() {
  window.addEventListener("resize", () => {
    const isMobileDevice = window.navigator.userAgent
      .toLowerCase()
      .includes("mobi");
    const element = document.getElementById("scheduler-header");
    if (
      window.matchMedia("(orientation: landscape)").matches &&
      isMobileDevice
    ) {
      element?.classList?.add("scrollable-header");
      /* showToast(ToastErrors.ORIENTATION_ERROR); */
    } else {
      element?.classList?.remove("scrollable-header");
    }
  });
}

function setDate() {
  if (!selectedDate.value) {
    store.commit(MutationTypes.SET_CURRENT_DATE, new Date());
  }
}

onMounted(async function () {
  try {
    setDate();
    await getPlaygrounds(myClub.value.club_id).then((val) => {
      const filtered = filteredPlaygrounds(val);
      playgrounds.value = refactorPlaygrounds(filtered);
      playgroundMap.value = { ...constructPlaygroundMap(filtered) };
    });
    await initializeEventsInCalendar();

    setInterval(() => {
      initializeEvents(selectedDate.value.toISOString(), true);
    }, 300000); // refresh ogni 5 minuti (300000ms)

    reportWindowSize(true);
    showCalendarBox.value = true;
    checkIfClubDisabled();
    // scrollToOpenedHour("special-hours-opened");
    handleButtonCalendarClickOut();
    handleOrientation();
  } catch (err) {
    return;
  }
});

//OGNI VOLTA CHE CAMBIA LA DATA RICHIEDI I TIMESLOTS
watch(selectedDate, async function (currentValue, oldValue) {
  try {
    await initializeEvents(currentValue.toISOString());
    // scrollToOpenedHour("special-hours-opened");
  } catch (e) {
    console.error(e);
  }
});

watch(showPriceRules, function (currentValue, oldValue) {
  if (currentValue === false) {
    setTimeout(() => {
      // scrollToOpenedHour("special-hours-opened");
    }, 250);
  }
});

function areFiltersTimeslotsApplied(filters) {
  return filters.length > 0 && isFilterActive(filters, "timeslot");
}

function calculateTimeFrom() {
  if (filtersTimeslotsApplied.value) {
    computedTimeFrom.value = filteredTimeFrom(
      clubTimeFrom,
      returnFilter("timeslot").value
    );
  } else {
    computedTimeFrom.value = clubTimeFrom;
  }
}

function calculateTimeTo() {
  if (filtersTimeslotsApplied.value) {
    computedTimeTo.value = filteredTimeTo(
      clubTimeTo,
      returnFilter("timeslot").value
    );
  } else {
    computedTimeTo.value = clubTimeTo;
  }
}

watch(activeFilters, async function (currentValue) {
  if (areFiltersTimeslotsApplied(currentValue)) {
    filtersTimeslotsApplied.value = true;
  } else {
    filtersTimeslotsApplied.value = false;
  }
  await calculateTimeFrom();
  await calculateTimeTo();
});

function handleCalendarDelete(event) {
  tempDeleted.value = event;
  display.value = true;
  events.value.push({
    playground_id: "",
    id: "000",
    start: null,
    end: null,
    title: "",
    class: "",
    split: 0,
  });
  const el = events.value.pop();
}

function arrayContainsElement(page, playground_id) {
  return page.find((pl) => pl.id === playground_id) ? true : false;
}

function goToPageThatContainsPlayground(playground_id: string) {
  const arrays = [];
  playgroundPages.value.forEach((page, index) => {
    arrayContainsElement(page, playground_id) ? arrays.push(index) : null;
  });
  arrays.length > 0
    ? (currentPage.value = arrays[0])
    : (currentPage.value = 0);
}

async function refreshPage() {
  await initializeEvents(selectedDate.value.toISOString());
}

function scrollOntoElement(start_at) {
  const labels = document.getElementsByClassName("vuecal__time-cell-label");
  Array.from(labels).forEach((lab) => {
    if ((lab as HTMLElement).innerText === start_at) {
      scrollIntoElement(lab);
    }
  });
}

function scrollToTime(timestamp) {
  store.commit(
    MutationTypes.SET_CURRENT_DATE,
    returnDateAdMidnight(new Date(timestamp))
  );
  setTimeout(() => {
    scrollOntoElement(transformMillisecondsToHHMM(timestamp));
  }, 100);
}

function goToPage(event, start_at) {
  scrollToTime(start_at);
  if (event.playground_id) {
    goToPageThatContainsPlayground(event.playground_id);
  }
}

async function deleteTimeslot(event: TimeslotInfo) {
  try {
    await store.dispatch(
      ActionTypes.DELETE_TIMESLOT,
      mapCancelBookingPayload(event, myClub.value.club_id)
    );
    await refreshPage();
    hideModal();
  } catch (err) {
    return;
  }
}

function handleDelete(event: CalendarTimeslot) {
  handleCalendarDelete(event);
  openModal("SURE_WANNA_DELETE");
  bookingToDelete.value = event.timeslotInfo;
}

async function handleTournamentSlot(event: CalendarTimeslot) {
  try {
    const resp = await store.dispatch(ActionTypes.GET_TOURNAMENT_DETAILS, {
      club_id: myClub.value.club_id,
      tournament_id: event.timeslotInfo.tournament_id,
    });
    tournamentDetails.value = resp;
    openModal("TOURNAMENT_DETAIL");
  } catch (error) {
    return;
  }
}

function handleClick(event: CalendarTimeslot) {
  if (event.timeslotInfo.type === BookingType.TOURNAMENT) {
    handleTournamentSlot(event);
  } else if (
    event.timeslotInfo.type === BookingType.OPEN_BOOKING ||
    event.timeslotInfo.type === BookingType.BACKOFFICE_OPEN_BOOKING
  ) {
    openMatchTimeslotId.value = event.timeslotInfo.id;
    openModal("BOOKING_DETAIL_OPEN_MATCH");
  } else {
    detailBooking.value = event;
    if (event.bundle_id) {
      openModal("BOOKING_BUNDLE_ALERT");
    } else {
      openModal("BOOKING_DETAIL");
    }
  }
}

function editBundle() {
  detailBooking.value.override_bundle = true;
  detailBooking.value.recurring = detailBooking.value.bundle_id != null;
  modalToShow.value = "BOOKING_DETAIL";
}

function editSingleBooking() {
  detailBooking.value.detach_bundle = true;
  modalToShow.value = "BOOKING_DETAIL";
}

function editTaking() {
  detailBooking.value.recurring = detailBooking.value.bundle_id != null;
  modalToShow.value = "BOOKING_TAKING";
}

function openNewBooking() {
  if (!isMyClubDisabled()) {
    openModal("NEW_BOOKING");
  } else {
    showToast(ToastErrors.CLUB_DISABLED);
  }
}

function getPlaygroundIdFromFakeEvent(event) {
  return splits.value.find((split) => split.id === event.split).playground;
}

function createFakeNewBookingEvent(event) {
  return {
    ...event,
    title: t("new_booking"),
    class: "fake-event",
    playground_id: getPlaygroundIdFromFakeEvent(event),
  };
}

function openNewBookingDrag(event) {
  const fakeEvent = createFakeNewBookingEvent(event);
  provvNewEvent.value = fakeEvent;
  events.value.push(fakeEvent);
  openNewBooking();
}

function eventOverlapsCreatedEvent(event: VueCalEvent) {
  const foundValue = events.value.find((val: CalendarTimeslot) => {
    const endMinutes =
      convertEventTimeToMinutesOfDay(val.end) === 0
        ? 1440
        : convertEventTimeToMinutesOfDay(val.end);
    return (
      moment(val.start).format("MM/DD/YYYY") ===
      moment(event.start).format("MM/DD/YYYY") &&
      val.split === event.split &&
      event.startTimeMinutes < endMinutes &&
      event.endTimeMinutes > convertEventTimeToMinutesOfDay(val.start)
    );
  });
  return Boolean(foundValue);
}

function adjustEvent(event: VueCalEvent) {
  let _provv = event;
  const minutesOfMorning = END_OF_MORNING / (60 * 1000);
  const minutesOfAfternoon = END_OF_AFTERNOON / (60 * 1000);
  const filter = returnFilter("timeslot").value;
  if (
    filter === CalendarOpenings.MORNING &&
    event.endTimeMinutes > minutesOfMorning
  ) {
    _provv = {
      ..._provv,
      endTimeMinutes: minutesOfMorning,
      end: new Date(changeDateTime(event.end, END_OF_MORNING)),
    };
  } else if (
    filter === CalendarOpenings.AFTERNOON &&
    event.endTimeMinutes > minutesOfAfternoon
  ) {
    console.log("filters applied: ", event);
    _provv = {
      ..._provv,
      endTimeMinutes: minutesOfAfternoon,
      end: new Date(changeDateTime(event.end, END_OF_AFTERNOON)),
    };
  }
  return _provv;
}

function handleDragCreate(event: VueCalEvent) {
  const endMinutes =
    event.endTimeMinutes === 0 ? 1440 : event.endTimeMinutes;
  if (event.start.getTime() === event.end.getTime()) {
    handleCalendarDelete(event);
  } else if (isMyClubDisabled()) {
    showToast(ToastErrors.CLUB_DISABLED);
    handleCalendarDelete(event);
  } else if (
    event.startTimeMinutes < timeFrom.value ||
    endMinutes > timeTo.value
  ) {
    openModal("EVENT_OVER_CLOSING_TIME");
    handleCalendarDelete(event);
  } else if (eventOverlapsCreatedEvent(event)) {
    openModal("EVENT_OVERLAPS");
    handleCalendarDelete(event);
  } else {
    if (filtersTimeslotsApplied.value) {
      event = adjustEvent(event);
    }
    openNewBookingDrag(event);
  }
}

function eliminateEvent() {
  const filtered = events.value.filter((value) => {
    return value.id !== tempDeleted.value.id;
  });
  events.value = filtered;
  display.value = false;
}

function abortEliminateEvent() {
  display.value = false;
}

function goToToday() {
  store.commit(MutationTypes.SET_CURRENT_DATE, new Date());
}

function goToYesterday() {
  store.commit(
    MutationTypes.SET_CURRENT_DATE,
    returnYesterday(selectedDate.value)
  );
}

function goToTomorrow() {
  store.commit(
    MutationTypes.SET_CURRENT_DATE,
    returnTomorrow(selectedDate.value)
  );
}

function formatDate() {
  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
    month: "long",
    day: "2-digit",
    year: "numeric",
  };
  const stringDate = selectedDate.value.toLocaleDateString(
    "it-IT",
    options
  );
  return (" " + stringDate)
    .replace(/ [\w]/g, (a) => a.toLocaleUpperCase())
    .trim();
}

function goToAddPlaygrounds() {
  router.push("add-playgrounds");
}

function goToTournaments() {
  router.push("tournaments");
}

function toggleCalendar() {
  show_calendar.value = !show_calendar.value;
}

function hideCalendar() {
  show_calendar.value = false;
}

function changeDateWithCalendar(event: Date) {
  if (event.getTime() === selectedDate.value.getTime()) return;
  setTimeout(() => {
    hideCalendar();
  }, 1);
  store.commit(MutationTypes.SET_CURRENT_DATE, new Date(event.getTime()));
}

function goToPreviousPage() {
  if (playgroundPages.value[currentPage.value - pageWindow]) {
    currentPage.value -= pageWindow;
  } else {
    currentPage.value = 0;
  }

  calculateSplits();
}

function goToNextPage() {
  if (playgroundPages.value[currentPage.value + pageWindow]) {
    currentPage.value += pageWindow;
  } else {
    currentPage.value = playgroundPages.value.length - 1;
  }
  calculateSplits();
}

function initializeActiveFilters() {
  activeFilters.value = [];
}

function setFilterFormValue(arrayIndex, obj) {
  filtersForm.value[arrayIndex].value = obj.value;
  filtersForm.value[arrayIndex].label = obj.label;
}

function toggleFilterFormValue(arrayIndex, value) {
  filtersForm.value[arrayIndex].value = value;
  filtersForm.value[arrayIndex].label = value ? t("private") : t("public");
}

function applyFilters() {
  activeFilters.value = mapCalendarFormToFilters(filtersForm.value);
  setTimeout(() => {
    const filtered = filteredPlaygrounds(
      allPlaygrounds.value,
      (returnFilter("playground") || {}).value,
      (returnFilter("sport") || {}).value,
      (returnFilter("visibility") || {}).value
    );
    playgrounds.value = refactorPlaygrounds(filtered);
    playgroundMap.value = { ...constructPlaygroundMap(filtered) };
    reportWindowSize(true);
    hideModal();
  }, 50);
}

function abortFilters() {
  initializeFilterForm();
  initializeActiveFilters();
  applyFilters();
}

function removeFilter(filter) {
  activeFilters.value = removedFilterArray(activeFilters.value, filter);
  const filtered = filteredPlaygrounds(
    allPlaygrounds.value,
    (returnFilter("playground") || {}).value,
    (returnFilter("sport") || {}).value,
    (returnFilter("visibility") || {}).value
  );
  playgrounds.value = refactorPlaygrounds(filtered);
  playgroundMap.value = { ...constructPlaygroundMap(filtered) };
  reportWindowSize(true);
}

function removeTimeslotFilter() {
  removeFilter({ type: "timeslot" });
}

function scrollOntoEvent(event) {
  if (event) {
    if (filtersTimeslotsApplied.value) {
      removeTimeslotFilter();
    }
    const start_at =
      event.type === BookingType.CLOSING
        ? mapTimestamp(
          transformStringToDate(event.date_from, "MM/DD/YYYY").getTime(),
          myClub.value.opening_hour
        )
        : event.start_at;
    goToPage(event, start_at);
  } else {
    refreshPage();
  }
  hideModal();
}

function logout() {
  store.dispatch(ActionTypes.LOGOUT, null);
  router.push("login");
}

async function hideModalAndRefresh() {
  hideModal();
  try {
    await refreshPage();
  } catch (err) {
    return;
  }
}

function getPlayground(id) {
  return allPlaygrounds.value.find((el) => el.id === id);
}

function switchCalendarView(value) {
  showPriceRules.value = value;
}

function showTooltip($event, id) {
  const rect = $event.srcElement.getBoundingClientRect();
  tooltipId.value = id;
  tooltipX.value = rect.x - 240;
  tooltipY.value = rect.bottom - rect.top + 25;
}

function hideTooltip() {
  tooltipId.value = null;
  tooltipX.value = null;
  tooltipY.value = null;
}

function checkBundle(event) {
  if (event) {
    store.commit(MutationTypes.SET_BUNDLE_RESPONSE, event);
    setTimeout(() => {
      router.push("confirm-bundle");
    }, 100);
  } else {
    refreshPage();
  }
  hideModal();
}

function setUploadPlayground(val) {
  uploadPlayground.value = val;
}

function isUploadEmpty(playground, file) {
  if (playground && file) return false;
  return true;
}

function fileAdded() {
  if (fileUploader.value && fileUploader.value.files) {
    try {
      const file = fileUploader.value.files[0];
      const extension = file.name.split(".").pop();

      if (extension != "csv") {
        fileUploader.value.files = [];
        return;
      }

      // SET
      uploadFile.value = file;
    } catch (e) {
      console.error(e);
    }
  }
}

function fileRemoved() {
  uploadFile.value = null;
}

async function uploadBookings() {
  try {
    await store.dispatch(ActionTypes.UPLOAD_BOOKING_CSV, {
      club_id: myClub.value.club_id,
      id: uploadPlayground.value.id,
      file: uploadFile.value,
    });
    // ALL GOOD
    uploadStep.value = 3;
  } catch (e) {
    console.error(e);
    alert(e);
    uploadStep.value = 4;
  }
}

function downloadCSV(url, name) {
  const link = document.createElement("a");
  link.setAttribute("download", name);
  link.href = url;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

function userSelected(user: PadelUser) {
  store.commit(MutationTypes.SET_SEARCH_USER, user);
  router.push({ name: "scheduled", params: { id: user.id } });
}

//METODO PER GESTIRE IL BUG DI VUE CAL CHE CHIAMA ENTRAMBI GLI EVENTI DI DELETE, DI CLICK E DRAG
function handleEvents(event_name, event) {
  if (event_name === "drag-create") {
    handleDragCreate(event);
  } else if (event_name === "dbl-click") {
    // PARSE
    const d = event.date;
    const y = d.getFullYear();
    const m = d.getMonth() < 9 ? `0${d.getMonth() + 1}` : d.getMonth() + 1;
    const dd = d.getDate();
    const hh = d.getHours() < 10 ? `0${d.getHours()}` : d.getHours();
    const string = `${y}-${m}-${dd} ${hh}:00`;

    // REFORMAT
    const tmpStart = moment(string);
    if (d.getMinutes() < 30) {
      tmpStart.set("minute", 0);
    } else {
      tmpStart.set("minute", 30);
    }
    const start = tmpStart.clone().toDate();
    const end = moment(start).add(1, "hour");
    const startTime =
      tmpStart.clone().hours() * 60 + tmpStart.clone().minutes();
    const endTime = end.clone().hours() * 60 + end.clone().minutes();

    // CREATE
    const mEvent = {
      _eid: "custom",
      allDay: false,
      background: false,
      class: "",
      content: "",
      daysCount: 1,
      end: end.toDate(),
      endTimeMinutes: endTime,
      split: event.split,
      start: start,
      startTimeMinutes: startTime,
      title: "",
      playground_id: splits.value[event.split].playground,
    };
    handleDragCreate(mEvent as VueCalEvent);
  } else if (event_name === "cell-click") {
    setTimeout(() => {
      if (!deleteClicked.value) {
        handleClick(event);
        deleteClicked.value = false;
      }
    }, 150);
  } else if (event_name === "event-delete") {
    deleteClicked.value = true;
    handleDelete(event);
    setTimeout(() => {
      deleteClicked.value = false;
    }, 300);
  } else if (event_name === "ready") {
    setTimeout(() => {
      const event = store.getters.getScrollEvent;
      if (event) {
        store.commit(MutationTypes.SET_SCROLL_EVENT, null);
        scrollOntoEvent(event);
        console.log('event', event);
      }
    }, 250);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_PadelToggle = _resolveComponent("PadelToggle")!
  const _component_PadelButton = _resolveComponent("PadelButton")!
  const _component_PadelCalendar = _resolveComponent("PadelCalendar")!
  const _component_UsersSearch = _resolveComponent("UsersSearch")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_PadelTooltip = _resolveComponent("PadelTooltip")!
  const _component_PricesCalendar = _resolveComponent("PricesCalendar")!
  const _component_PadelDropdown = _resolveComponent("PadelDropdown")!
  const _component_PadelRadio = _resolveComponent("PadelRadio")!
  const _component_DumbModal = _resolveComponent("DumbModal")!
  const _component_TournamentDetailModal = _resolveComponent("TournamentDetailModal")!
  const _component_BookingDetailModal = _resolveComponent("BookingDetailModal")!
  const _component_OpenBookingDetail = _resolveComponent("OpenBookingDetail")!
  const _component_NewBookingModal = _resolveComponent("NewBookingModal")!
  const _component_BookingTakingModal = _resolveComponent("BookingTakingModal")!
  const _component_ADFileUpload = _resolveComponent("ADFileUpload")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("p", _hoisted_3, [
          _createTextVNode(_toDisplayString(_unref(t)('calendar')) + " ", 1),
          _createVNode(_component_PadelToggle, {
            checked: showPriceRules.value,
            "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => (showPriceRules.value = $event)),
            onChange: _cache[2] || (_cache[2] = ($event: any) => (switchCalendarView($event))),
            containerClass: "p-d-inline-flex p-ml-2",
            labelClass: "color-white overflow-inherit font-12",
            label: _unref(t)('prices_and_hours')
          }, null, 8, ["checked", "label"])
        ]),
        (!showPriceRules.value)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", {
                class: ["scheduler-button export-button cursor-pointer display-flex", [playgrounds.value.length > 0 ? '' : 'disabled']],
                onClick: _cache[3] || (_cache[3] = ($event: any) => (openModal('UPLOAD_EXCEL')))
              }, [
                _createVNode("p", {
                  class: ["scheduler-button-text color-blue", [playgrounds.value.length > 0 ? '' : 'disabled']]
                }, _toDisplayString(_unref(uppercase)(_unref(t)('import'))), 3),
                _createVNode("i", {
                  class: ["material-icons color-blue", [playgrounds.value.length > 0 ? '' : 'disabled']]
                }, "file_upload", 2)
              ], 2),
              _hoisted_5,
              _createVNode("div", {
                class: ["scheduler-button refresh-button cursor-pointer display-flex", [playgrounds.value.length > 0 ? '' : 'disabled']],
                onClick: _cache[4] || (_cache[4] = ($event: any) => (refreshPage()))
              }, [
                _createVNode("p", {
                  class: ["scheduler-button-text color-blue", [playgrounds.value.length > 0 ? '' : 'disabled']]
                }, _toDisplayString(_unref(uppercase)(_unref(t)('refresh'))), 3),
                _createVNode("i", {
                  class: ["material-icons color-blue", [playgrounds.value.length > 0 ? '' : 'disabled']]
                }, "refresh", 2)
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      (!showPriceRules.value)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("div", {
              class: ["display-flex calendar-selector", [playgrounds.value.length > 0 ? '' : 'disabled']]
            }, [
              _createVNode(_component_PadelButton, {
                type: "dark",
                label: _unref(uppercase)(_unref(t)('today')),
                class: "margin-right-20",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (goToToday()))
              }, null, 8, ["label"]),
              _createVNode("i", {
                class: ["pi pi-chevron-left color-blue cursor-pointer", [playgrounds.value.length > 0 ? '' : 'disabled']],
                onClick: _cache[6] || (_cache[6] = ($event: any) => (goToYesterday()))
              }, null, 2),
              _createVNode("i", {
                class: ["pi pi-chevron-right color-blue cursor-pointer", [playgrounds.value.length > 0 ? '' : 'disabled']],
                onClick: _cache[7] || (_cache[7] = ($event: any) => (goToTomorrow()))
              }, null, 2),
              _createVNode("div", {
                class: "selected-date cursor-pointer",
                id: "toggle-calendar-button",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (toggleCalendar()))
              }, _toDisplayString(_unref(selectedDate) ? formatDate() : ''), 1),
              _createVNode("div", {
                class: [show_calendar.value ? '' : 'display-none', "calendar-container-scheduler"]
              }, [
                _createVNode(_component_PadelCalendar, {
                  showLabel: false,
                  onInput: _cache[9] || (_cache[9] = ($event: any) => (changeDateWithCalendar($event))),
                  class: "calendaaar",
                  id: "calendar-scheduler-box",
                  value: _unref(selectedDate)
                }, null, 8, ["value"])
              ], 2)
            ], 2),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_UsersSearch, {
                  onUserSelected: userSelected,
                  old: true
                })
              ]),
              _hoisted_9,
              _createVNode("div", {
                class: ["scheduler-button cursor-pointer display-flex", [playgrounds.value.length > 0 ? '' : 'disabled']],
                onClick: _cache[10] || (_cache[10] = ($event: any) => (openModal('FILTER')))
              }, [
                _createVNode("p", {
                  class: ["scheduler-button-text color-blue", [playgrounds.value.length > 0 ? '' : 'disabled']]
                }, _toDisplayString(_unref(uppercase)(_unref(t)('filters'))), 3),
                _createVNode("i", {
                  class: ["material-icons color-blue", [playgrounds.value.length > 0 ? '' : 'disabled']]
                }, "filter_alt", 2)
              ], 2),
              _hoisted_10,
              _createVNode("div", {
                class: ["scheduler-button cursor-pointer display-flex", _unref(new__booking)],
                onClick: _cache[11] || (_cache[11] = ($event: any) => (openNewBooking()))
              }, [
                _createVNode("p", {
                  class: ["scheduler-button-text color-blue", _unref(new__booking)]
                }, _toDisplayString(_unref(uppercase)(_unref(t)('new_booking'))), 3),
                _createVNode("i", {
                  class: ["pi pi-plus color-blue", _unref(new__booking)]
                }, null, 2)
              ], 2)
            ])
          ]))
        : _createCommentVNode("", true),
      (activeFilters.value.length > 0 && !showPriceRules.value)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(activeFilters.value, (chip, index) => {
              return (_openBlock(), _createBlock(_component_Chip, {
                key: index,
                class: "chip-table"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_12, [
                    _createVNode("span", _hoisted_13, _toDisplayString(chip.type === 'timeslot' ? _unref(uppercase)(_unref(t)(chip.label)) :
              _unref(uppercase)(chip.label)), 1),
                    _createVNode("span", {
                      class: "material-icons icon-close-chip",
                      onClick: ($event: any) => (removeFilter(chip))
                    }, " close ", 8, ["onClick"])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (activeFilters.value.length > 0 && _unref(isFilterActive)(activeFilters.value, 'playground') && !showPriceRules.value)
        ? (_openBlock(), _createBlock("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                (activeFilters.value[0].value.playground_image)
                  ? (_openBlock(), _createBlock(_component_Avatar, {
                      key: 0,
                      shape: "circle",
                      image: activeFilters.value[0].value.playground_image
                    }, null, 8, ["image"]))
                  : (_openBlock(), _createBlock("img", _hoisted_17))
              ]),
              _createVNode("div", _hoisted_18, [
                _createVNode("div", _hoisted_19, _toDisplayString(activeFilters.value[0].value.name || '-'), 1),
                _createVNode("div", _hoisted_20, [
                  _createTextVNode(_toDisplayString(_unref(getSportByValue)(activeFilters.value[0].value.sport)), 1),
                  _hoisted_21,
                  _createTextVNode(" " + _toDisplayString(_unref(t)(activeFilters.value[0].value.hidden ? 'private' : 'public')), 1)
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode("span", {
                    class: "i-icon margin-left-10 material-icons-outlined cursor-pointer color-blue",
                    id: "info-icon",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (showTooltip($event, activeFilters.value[0].value.id)))
                  }, " info ")
                ]),
                (tooltipId.value == activeFilters.value[0].value.id)
                  ? (_openBlock(), _createBlock(_component_PadelTooltip, {
                      key: 0,
                      absolute: true,
                      x: tooltipX.value,
                      y: tooltipY.value,
                      dark: true,
                      class: "tooltip",
                      arrowPosition: 'NONE',
                      content: _unref(mapContentForTooltip)(activeFilters.value[0].value, _unref(t)),
                      onClose: hideTooltip
                    }, null, 8, ["x", "y", "content"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : (playgrounds.value.length > 0 && splits.value.length > 0 && !showPriceRules.value)
          ? (_openBlock(), _createBlock("div", _hoisted_23, [
              (currentPage.value > 0)
                ? (_openBlock(), _createBlock(_component_PadelButton, {
                    key: 0,
                    class: "left-button position-absolute",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (goToPreviousPage())),
                    icon: 'chevron_left'
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(playgroundPages.value[currentPage.value], (playground) => {
                return (_openBlock(), _createBlock("div", {
                  key: playground.id,
                  class: "table-head display-flex"
                }, [
                  _createVNode("div", _hoisted_24, [
                    (playground.playground_image)
                      ? (_openBlock(), _createBlock(_component_Avatar, {
                          key: 0,
                          shape: "circle",
                          image: playground.playground_image
                        }, null, 8, ["image"]))
                      : (_openBlock(), _createBlock("img", _hoisted_25))
                  ]),
                  _createVNode("div", _hoisted_26, [
                    _createVNode("div", _hoisted_27, _toDisplayString(playground.name || '-'), 1),
                    _createVNode("div", _hoisted_28, [
                      _createTextVNode(_toDisplayString(_unref(getSportByValue)(playground.sport)), 1),
                      _hoisted_29,
                      _createTextVNode(" " + _toDisplayString(_unref(t)(playground.hidden ? 'private' : 'public')), 1)
                    ]),
                    _createVNode("div", _hoisted_30, [
                      _createVNode("span", {
                        class: "i-icon margin-left-10 material-icons-outlined cursor-pointer color-blue",
                        id: "info-icon",
                        onClick: ($event: any) => (showTooltip($event, playground.id))
                      }, " info ", 8, ["onClick"])
                    ]),
                    (tooltipId.value == playground.id)
                      ? (_openBlock(), _createBlock(_component_PadelTooltip, {
                          key: 0,
                          absolute: true,
                          x: tooltipX.value,
                          y: tooltipY.value,
                          dark: true,
                          class: "tooltip",
                          arrowPosition: 'NONE',
                          content: _unref(mapContentForTooltip)(playground, _unref(t)),
                          onClose: hideTooltip
                        }, null, 8, ["x", "y", "content"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128)),
              (currentPage.value < playgroundPages.value.length - 1)
                ? (_openBlock(), _createBlock(_component_PadelButton, {
                    key: 1,
                    class: "right-button position-absolute",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (goToNextPage())),
                    icon: 'chevron_right'
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
    ]),
    (playgrounds.value.length > 0 && splits.value.length > 0 && !showPriceRules.value)
      ? (_openBlock(), _createBlock("div", _hoisted_31, [
          _createVNode(_unref(VueCal), {
            "time-cell-height": timeCellHeight.value,
            "selected-date": _unref(formatDateYYYYMMDD)(_unref(selectedDate)),
            locale: "it",
            "time-from": computedTimeFrom.value,
            "time-to": computedTimeTo.value,
            "hide-view-selector": "",
            "disable-views": ['years', 'year', 'month', 'week'],
            "hide-weekends": "",
            "time-step": 30,
            "special-hours": specialHours.value,
            "min-event-width": 100,
            snapToTime: 30,
            "editable-events": { delete: true, create: _unref(createValue) },
            events: _unref(computedEvents),
            "split-days": _unref(computedSplits),
            onReady: _cache[15] || (_cache[15] = ($event: any) => (handleEvents('ready', $event))),
            onEventDelete: _cache[16] || (_cache[16] = ($event: any) => (handleEvents('event-delete', $event))),
            onEventDragCreate: _cache[17] || (_cache[17] = ($event: any) => (handleEvents('drag-create', $event))),
            onEventFocus: _cache[18] || (_cache[18] = ($event: any) => (handleEvents('cell-click', $event))),
            onCellDblclick: _cache[19] || (_cache[19] = ($event: any) => (handleEvents('dbl-click', $event)))
          }, null, 8, ["time-cell-height", "selected-date", "time-from", "time-to", "special-hours", "editable-events", "events", "split-days"]),
          _createVNode("div", _hoisted_32, _toDisplayString(_unref(convertMinutesOfDayToHHMM)(computedTimeTo.value)), 1)
        ]))
      : (showCalendarBox.value && playgrounds.value.length <= 0 && !showPriceRules.value)
        ? (_openBlock(), _createBlock("div", _hoisted_33, [
            _hoisted_34,
            _createVNode("div", _hoisted_35, _toDisplayString(_unref(t)('playgrounds_missing')) + ". ", 1),
            _createVNode("div", _hoisted_36, [
              _createTextVNode(_toDisplayString(_unref(t)('start_handle_bookings')) + " ", 1),
              _createVNode("b", null, _toDisplayString('"' + _unref(t)('my_club').toLowerCase() + '"'), 1),
              _createTextVNode(" " + _toDisplayString(_unref(t)('and_insert_playground')), 1)
            ]),
            _createVNode("div", {
              class: "scheduler-button new-event-button cursor-pointer display-flex margin-top-20",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (goToAddPlaygrounds()))
            }, [
              _createVNode("p", _hoisted_37, _toDisplayString(_unref(uppercase)(_unref(t)('add_playground'))), 1),
              _hoisted_38
            ])
          ]))
        : _createCommentVNode("", true),
    (showPriceRules.value)
      ? (_openBlock(), _createBlock("div", _hoisted_39, [
          _createVNode(_component_PricesCalendar, {
            containerClass: "in-scheduler",
            withSelectedDate: _unref(selectedDate),
            onlyAllPlaygrounds: true
          }, null, 8, ["withSelectedDate"])
        ]))
      : _createCommentVNode("", true),
    (modalToShow.value === 'FILTER')
      ? (_openBlock(), _createBlock("div", _hoisted_40, [
          _createVNode(_component_DumbModal, {
            title: _unref(t)('filter_club_requests'),
            isVisible: true,
            onHide: _cache[29] || (_cache[29] = ($event: any) => (hideModal()))
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _createVNode(_component_PadelDropdown, {
                      class: "dropdown",
                      onInput: _cache[21] || (_cache[21] = ($event: any) => (setFilterFormValue(2, $event))),
                      default: filtersForm.value[2].value,
                      options: _unref(mySports),
                      label: _unref(t)('sport_choice')
                    }, null, 8, ["default", "options", "label"])
                  ]),
                  _createVNode("div", _hoisted_44, [
                    _createVNode(_component_PadelDropdown, {
                      class: "dropdown",
                      onInput: _cache[22] || (_cache[22] = ($event: any) => (setFilterFormValue(0, $event))),
                      default: filtersForm.value[0].value,
                      options: _unref(computedPlaygrounds),
                      label: _unref(t)('playground_choice')
                    }, null, 8, ["default", "options", "label"])
                  ]),
                  _createVNode("div", _hoisted_45, [
                    _createVNode("p", _hoisted_46, _toDisplayString(_unref(t)('calendar_slot')), 1),
                    _createVNode(_component_PadelRadio, {
                      value: filtersForm.value[1].value,
                      options: _unref(computedCalendarFilterOptions),
                      chipMode: true,
                      onInput: _cache[23] || (_cache[23] = ($event: any) => (setFilterFormValue(1, { value: $event, label: $event })))
                    }, null, 8, ["value", "options"])
                  ]),
                  _createVNode("div", _hoisted_47, [
                    _createVNode("p", _hoisted_48, _toDisplayString(_unref(t)('playground_visibility')), 1),
                    _createVNode(_component_PadelToggle, {
                      checked: filtersForm.value[3].value,
                      "onUpdate:checked": _cache[24] || (_cache[24] = ($event: any) => (filtersForm.value[3].value = $event)),
                      onChange: _cache[25] || (_cache[25] = ($event: any) => (toggleFilterFormValue(3, $event))),
                      labelClass: "color-white overflow-inherit",
                      label: _unref(t)('private')
                    }, null, 8, ["checked", "label"])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_49, [
                _createVNode("div", null, [
                  _createVNode("p", {
                    class: "abort center-button",
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (abortFilters()))
                  }, _toDisplayString(_unref(uppercase)(_unref(t)('abort'))), 1)
                ]),
                _createVNode("div", _hoisted_50, [
                  _createVNode(_component_PadelButton, {
                    class: "margin-right-20",
                    label: _unref(uppercase)(_unref(t)('reset_filters')),
                    type: 'secondary',
                    onClick: _cache[27] || (_cache[27] = ($event: any) => (initializeFilterForm()))
                  }, null, 8, ["label"]),
                  _createVNode(_component_PadelButton, {
                    label: _unref(uppercase)(_unref(t)('apply')),
                    type: 'primary',
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (applyFilters()))
                  }, null, 8, ["label"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["title"])
        ]))
      : (modalToShow.value === 'TOURNAMENT_DETAIL')
        ? (_openBlock(), _createBlock("div", _hoisted_51, [
            _createVNode(_component_TournamentDetailModal, {
              tournament: tournamentDetails.value,
              onGoToTournaments: _cache[30] || (_cache[30] = ($event: any) => (goToTournaments())),
              onHideModal: _cache[31] || (_cache[31] = ($event: any) => (hideModal()))
            }, null, 8, ["tournament"])
          ]))
        : (modalToShow.value === 'BOOKING_DETAIL')
          ? (_openBlock(), _createBlock("div", _hoisted_52, [
              _createVNode(_component_BookingDetailModal, {
                booking: detailBooking.value,
                playgroundMap: playgroundMap.value,
                hasCards: userHasCards.value,
                playgroundOptions: _unref(playgroundOptions),
                onHideModal: _cache[32] || (_cache[32] = ($event: any) => (hideModalAndRefresh())),
                openingHour: timeFrom.value / 60,
                closingHour: timeTo.value / 60,
                sportsOptions: _unref(sportOptions),
                onOnCancel: _cache[33] || (_cache[33] = ($event: any) => (handleDelete(detailBooking.value))),
                onCreationCompleted: _cache[34] || (_cache[34] = ($event: any) => (scrollOntoEvent($event))),
                onCheckBundle: _cache[35] || (_cache[35] = ($event: any) => (checkBundle($event)))
              }, null, 8, ["booking", "playgroundMap", "hasCards", "playgroundOptions", "openingHour", "closingHour", "sportsOptions"])
            ]))
          : (modalToShow.value === 'BOOKING_DETAIL_OPEN_MATCH')
            ? (_openBlock(), _createBlock("div", _hoisted_53, [
                _createVNode(_component_OpenBookingDetail, {
                  id: openMatchTimeslotId.value,
                  onHideModal: _cache[36] || (_cache[36] = ($event: any) => (hideModalAndRefresh())),
                  onOnCancel: _cache[37] || (_cache[37] = ($event: any) => (handleDelete(detailBooking.value))),
                  onCreationCompleted: _cache[38] || (_cache[38] = ($event: any) => (scrollOntoEvent($event))),
                  onCheckBundle: _cache[39] || (_cache[39] = ($event: any) => (checkBundle($event)))
                }, null, 8, ["id"])
              ]))
            : (modalToShow.value === 'NEW_BOOKING')
              ? (_openBlock(), _createBlock("div", _hoisted_54, [
                  _createVNode(_component_NewBookingModal, {
                    playgroundMap: playgroundMap.value,
                    playgroundOptions: _unref(playgroundOptions),
                    sportsOptions: _unref(sportOptions),
                    openingHour: timeFrom.value / 60,
                    closingHour: timeTo.value / 60,
                    onHideModal: _cache[40] || (_cache[40] = ($event: any) => (hideModalAndRefresh())),
                    provvNewEvent: provvNewEvent.value,
                    onRefreshPage: _cache[41] || (_cache[41] = ($event: any) => (refreshPage())),
                    selectedDate: _unref(selectedDate),
                    onCreationCompleted: _cache[42] || (_cache[42] = ($event: any) => (scrollOntoEvent($event))),
                    onCheckBundle: _cache[43] || (_cache[43] = ($event: any) => (checkBundle($event)))
                  }, null, 8, ["playgroundMap", "playgroundOptions", "sportsOptions", "openingHour", "closingHour", "provvNewEvent", "selectedDate"])
                ]))
              : (modalToShow.value === 'BOOKING_TAKING')
                ? (_openBlock(), _createBlock("div", _hoisted_55, [
                    _createVNode(_component_BookingTakingModal, {
                      booking: detailBooking.value,
                      onHideModal: _cache[44] || (_cache[44] = ($event: any) => (hideModalAndRefresh())),
                      onCreationCompleted: _cache[45] || (_cache[45] = ($event: any) => (scrollOntoEvent($event)))
                    }, null, 8, ["booking"])
                  ]))
                : (modalToShow.value === 'SURE_WANNA_DELETE')
                  ? (_openBlock(), _createBlock("div", _hoisted_56, [
                      _createVNode(_component_DumbModal, {
                        title: bookingToDelete.value.type === 'BOOKING' ?
      _unref(t)('eliminate_app_timeslot_title') : _unref(t)('eliminate_timeslot_title'),
                        onHide: _cache[48] || (_cache[48] = ($event: any) => (hideModal()))
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_57, [
                            _hoisted_58,
                            _createVNode("div", _hoisted_59, _toDisplayString(_unref(t)('attention')), 1),
                            (bookingToDelete.value.type === 'BOOKING')
                              ? (_openBlock(), _createBlock("div", _hoisted_60, _toDisplayString(_unref(t)('app_timeslot_warning')), 1))
                              : (!!bookingToDelete.value.bundle_id)
                                ? (_openBlock(), _createBlock("div", {
                                    key: 1,
                                    class: "color-white alert-text montserrat",
                                    innerHTML: _unref(t)('eliminate_timeslot_from_bundle_text', { type: _unref(t)(bookingToDelete.value.type) })
                                  }, null, 8, ["innerHTML"]))
                                : (_openBlock(), _createBlock("div", {
                                    key: 2,
                                    class: "color-white alert-text montserrat",
                                    innerHTML: _unref(t)('eliminate_timeslot_text', { type: _unref(t)(bookingToDelete.value.type) })
                                  }, null, 8, ["innerHTML"])),
                            _createVNode("div", _hoisted_61, _toDisplayString(_unref(t)('sure_wanna_continue_timeslot_delete')), 1),
                            (bookingToDelete.value.payment_choice === 'ONLINE' && bookingToDelete.value.nexi_transaction_id !== undefined && bookingToDelete.value.nexi_transaction_id !== null)
                              ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                                  _createVNode("div", _hoisted_62, [
                                    _createVNode("span", _hoisted_63, "Prenotazione pagata con carta di credito - €" + _toDisplayString((bookingToDelete.value.price / 100).toFixed(2)), 1)
                                  ]),
                                  _hoisted_64
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", _hoisted_65, [
                            _createVNode("div", null, [
                              _createVNode("p", {
                                class: "abort center-button",
                                onClick: _cache[46] || (_cache[46] = ($event: any) => (hideModal()))
                              }, _toDisplayString(_unref(uppercase)(_unref(t)('abort'))), 1)
                            ]),
                            _createVNode("div", _hoisted_66, [
                              _createVNode(_component_PadelButton, {
                                label: _unref(uppercase)(_unref(t)('confirm')),
                                type: 'primary',
                                onClick: _cache[47] || (_cache[47] = ($event: any) => (deleteTimeslot(bookingToDelete.value)))
                              }, null, 8, ["label"])
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["title"])
                    ]))
                  : (modalToShow.value === 'CLUB_DISABLED')
                    ? (_openBlock(), _createBlock("div", _hoisted_67, [
                        _createVNode(_component_DumbModal, {
                          title: _unref(t)('disabled_club'),
                          onHide: _cache[51] || (_cache[51] = ($event: any) => (hideModal()))
                        }, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_68, [
                              _hoisted_69,
                              _createVNode("div", _hoisted_70, _toDisplayString(_unref(t)('attention')), 1),
                              _createVNode("div", {
                                class: "color-white alert-text montserrat",
                                innerHTML: _unref(t)('disabled_club_modal_text', { mail: 'info@wesmash.it' })
                              }, null, 8, ["innerHTML"])
                            ]),
                            _createVNode("div", _hoisted_71, [
                              _createVNode("div", null, [
                                _createVNode("p", {
                                  class: "abort center-button",
                                  onClick: _cache[49] || (_cache[49] = ($event: any) => (logout()))
                                }, _toDisplayString(_unref(uppercase)(_unref(t)('exit'))), 1)
                              ]),
                              _createVNode("div", _hoisted_72, [
                                _createVNode(_component_PadelButton, {
                                  label: _unref(uppercase)(_unref(t)('get_in')),
                                  type: 'primary',
                                  onClick: _cache[50] || (_cache[50] = ($event: any) => (hideModal()))
                                }, null, 8, ["label"])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["title"])
                      ]))
                    : (modalToShow.value === 'EVENT_OVER_CLOSING_TIME')
                      ? (_openBlock(), _createBlock("div", _hoisted_73, [
                          _createVNode(_component_DumbModal, {
                            title: _unref(t)('new_booking'),
                            onHide: _cache[53] || (_cache[53] = ($event: any) => (hideModal()))
                          }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_74, [
                                _hoisted_75,
                                _createVNode("div", _hoisted_76, _toDisplayString(_unref(t)('attention')), 1),
                                _createVNode("div", _hoisted_77, _toDisplayString(_unref(t)('event_over_closing_time')), 1)
                              ]),
                              _createVNode("div", _hoisted_78, [
                                _createVNode("div", null, [
                                  _createVNode("p", {
                                    class: "abort center-button",
                                    onClick: _cache[52] || (_cache[52] = ($event: any) => (hideModal()))
                                  }, _toDisplayString(_unref(uppercase)(_unref(t)('close'))), 1)
                                ])
                              ])
                            ]),
                            _: 1
                          }, 8, ["title"])
                        ]))
                      : (modalToShow.value === 'EVENT_OVERLAPS')
                        ? (_openBlock(), _createBlock("div", _hoisted_79, [
                            _createVNode(_component_DumbModal, {
                              title: _unref(t)('new_booking'),
                              onHide: _cache[55] || (_cache[55] = ($event: any) => (hideModal()))
                            }, {
                              default: _withId(() => [
                                _createVNode("div", _hoisted_80, [
                                  _hoisted_81,
                                  _createVNode("div", _hoisted_82, _toDisplayString(_unref(t)('attention')), 1),
                                  _createVNode("div", _hoisted_83, _toDisplayString(_unref(t)('event_overlaps')), 1)
                                ]),
                                _createVNode("div", _hoisted_84, [
                                  _createVNode("div", null, [
                                    _createVNode("p", {
                                      class: "abort center-button",
                                      onClick: _cache[54] || (_cache[54] = ($event: any) => (hideModal()))
                                    }, _toDisplayString(_unref(uppercase)(_unref(t)('close'))), 1)
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["title"])
                          ]))
                        : (modalToShow.value === 'UPLOAD_EXCEL')
                          ? (_openBlock(), _createBlock("div", _hoisted_85, [
                              _createVNode(_component_DumbModal, {
                                title: _unref(t)('import_bookings'),
                                onHide: _cache[62] || (_cache[62] = ($event: any) => (hideModal()))
                              }, {
                                default: _withId(() => [
                                  (uploadStep.value === 1)
                                    ? (_openBlock(), _createBlock("div", _hoisted_86, [
                                        _createVNode("div", _hoisted_87, _toDisplayString(_unref(t)('import_bookings_text')), 1),
                                        _createVNode("div", _hoisted_88, [
                                          _createVNode("div", _hoisted_89, [
                                            _createVNode("div", _hoisted_90, [
                                              _hoisted_91,
                                              _hoisted_92,
                                              _createTextVNode(" " + _toDisplayString(_unref(uppercase)(_unref(t)('download_pdf'))), 1)
                                            ])
                                          ]),
                                          _createVNode("div", _hoisted_93, [
                                            _createVNode("div", {
                                              class: "download-button",
                                              onClick: _cache[56] || (_cache[56] = ($event: any) => (downloadCSV('/import_bookings_sample.csv', 'import_bookings_sample.csv')))
                                            }, [
                                              _hoisted_94,
                                              _hoisted_95,
                                              _createTextVNode(" " + _toDisplayString(_unref(uppercase)(_unref(t)('download_csv_template'))), 1)
                                            ])
                                          ])
                                        ])
                                      ]))
                                    : (uploadStep.value === 2)
                                      ? (_openBlock(), _createBlock("div", _hoisted_96, [
                                          _createVNode("div", _hoisted_97, [
                                            _createVNode(_component_PadelDropdown, {
                                              onInput: _cache[57] || (_cache[57] = ($event: any) => (setUploadPlayground($event.value))),
                                              label: _unref(t)('playground_choice'),
                                              default: uploadPlayground.value,
                                              options: _unref(playgroundOptions),
                                              isDropdownInModal: _ctx.isModal
                                            }, null, 8, ["label", "default", "options", "isDropdownInModal"])
                                          ]),
                                          _createVNode("div", _hoisted_98, [
                                            _createVNode(_component_ADFileUpload, {
                                              ref: fileUploader,
                                              mode: "custom",
                                              accept: '.csv',
                                              maxFileSize: 1000000,
                                              fileLimit: 1,
                                              chooseLabel: _ctx.$t('upload_csv_file'),
                                              showUploadButton: false,
                                              showCancelButton: false,
                                              onChange: fileAdded,
                                              onRemove: fileRemoved
                                            }, null, 8, ["accept", "chooseLabel"])
                                          ])
                                        ]))
                                      : (uploadStep.value === 3)
                                        ? (_openBlock(), _createBlock("div", _hoisted_99, [
                                            _createVNode("div", _hoisted_100, [
                                              _hoisted_101,
                                              _createVNode("div", _hoisted_102, [
                                                _createVNode("strong", null, _toDisplayString(_unref(t)('Elaborating file')), 1)
                                              ]),
                                              _createVNode("div", {
                                                class: "color-white alert-text montserrat",
                                                innerHTML: _unref(t)('Send report after')
                                              }, null, 8, ["innerHTML"])
                                            ])
                                          ]))
                                        : (uploadStep.value === 4)
                                          ? (_openBlock(), _createBlock("div", _hoisted_103, [
                                              _createVNode("div", _hoisted_104, [
                                                _hoisted_105,
                                                _createVNode("div", _hoisted_106, [
                                                  _createVNode("strong", null, _toDisplayString(_unref(t)('Something went wrong')), 1)
                                                ]),
                                                _createVNode("div", {
                                                  class: "color-white alert-text montserrat",
                                                  innerHTML: _unref(t)('Try to upload again')
                                                }, null, 8, ["innerHTML"])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                  _createVNode("div", _hoisted_107, [
                                    (uploadStep.value === 1 || uploadStep.value === 2)
                                      ? (_openBlock(), _createBlock("p", {
                                          key: 0,
                                          class: "abort center-button",
                                          onClick: _cache[58] || (_cache[58] = ($event: any) => (hideModal()))
                                        }, _toDisplayString(_unref(uppercase)(_unref(t)('abort'))), 1))
                                      : _createCommentVNode("", true),
                                    (uploadStep.value === 1)
                                      ? (_openBlock(), _createBlock(_component_PadelButton, {
                                          key: 1,
                                          label: _unref(uppercase)(_unref(t)('proceed')),
                                          type: 'primary',
                                          onClick: _cache[59] || (_cache[59] = ($event: any) => (uploadStep.value = 2))
                                        }, null, 8, ["label"]))
                                      : _createCommentVNode("", true),
                                    (uploadStep.value === 2)
                                      ? (_openBlock(), _createBlock(_component_PadelButton, {
                                          key: 2,
                                          label: _unref(uppercase)(_unref(t)('load')),
                                          type: 'primary',
                                          disabled: isUploadEmpty(uploadPlayground.value, uploadFile.value),
                                          onClick: _cache[60] || (_cache[60] = ($event: any) => (uploadBookings()))
                                        }, null, 8, ["label", "disabled"]))
                                      : _createCommentVNode("", true),
                                    (uploadStep.value === 3 || uploadStep.value === 4)
                                      ? (_openBlock(), _createBlock(_component_PadelButton, {
                                          key: 3,
                                          label: _unref(uppercase)(_unref(t)('close')),
                                          type: 'primary',
                                          onClick: _cache[61] || (_cache[61] = ($event: any) => (hideModal()))
                                        }, null, 8, ["label"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["title"])
                            ]))
                          : (modalToShow.value === 'BOOKING_BUNDLE_ALERT')
                            ? (_openBlock(), _createBlock("div", _hoisted_108, [
                                _createVNode(_component_DumbModal, {
                                  title: _unref(t)('edit_booking'),
                                  onHide: _cache[66] || (_cache[66] = ($event: any) => (hideModal()))
                                }, {
                                  default: _withId(() => [
                                    _createVNode("div", _hoisted_109, [
                                      _hoisted_110,
                                      _createVNode("div", _hoisted_111, _toDisplayString(_unref(t)('attention')), 1),
                                      _createVNode("div", {
                                        class: "color-white alert-text montserrat",
                                        innerHTML: _unref(t)('editing_bundle')
                                      }, null, 8, ["innerHTML"])
                                    ]),
                                    _createVNode("div", _hoisted_112, [
                                      (detailBooking.value.timeslotInfo.type === 'BOOKING' || detailBooking.value.timeslotInfo.type === 'BACKOFFICE_BOOKING' || detailBooking.value.timeslotInfo.type === 'LESSON' || detailBooking.value.timeslotInfo.type === 'BACKOFFICE_LESSON')
                                        ? (_openBlock(), _createBlock("div", _hoisted_113, [
                                            _createVNode(_component_PadelButton, {
                                              label: _unref(uppercase)(_unref(t)('edit_taking')),
                                              type: 'secondary',
                                              onClick: _cache[63] || (_cache[63] = ($event: any) => (editTaking()))
                                            }, null, 8, ["label"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createVNode("div", _hoisted_114, [
                                        _createVNode(_component_PadelButton, {
                                          label: _unref(uppercase)(_unref(t)('whole_bundle')),
                                          type: 'secondary',
                                          onClick: _cache[64] || (_cache[64] = ($event: any) => (editBundle()))
                                        }, null, 8, ["label"])
                                      ]),
                                      _createVNode("div", _hoisted_115, [
                                        _createVNode(_component_PadelButton, {
                                          label: _unref(uppercase)(_unref(t)('single_booking')),
                                          type: 'primary',
                                          onClick: _cache[65] || (_cache[65] = ($event: any) => (editSingleBooking()))
                                        }, null, 8, ["label"])
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["title"])
                              ]))
                            : _createCommentVNode("", true)
  ], 64))
}
}

})